import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogTitleActions,
  Type,
  List,
  Flex,
  TabContext,
  TabList,
  TabPanel,
  TabPanels,
  Divider,
  Card,
  CardContent,
} from "discover.medical.react-component-library";
import {
  DrugInteractionKeyTab,
  DrugInteractionKeyIcon,
  DrugInteractionKeyTitle,
  DrugInteractionKeyTitleListItemWrapper,
  DrugInteractionKeyItemTextContent,
  DrugInteractionKeyTitleListItem,
} from "./styled";

const SeverityInfoModal = ({
  title,
  definitions,
  documentationRatings,
  handleClose,
  isOpen,
}) => {
  return (
    <Dialog isOpen={isOpen} onRequestClose={handleClose} maxWidth="md">
      <DialogTitle>
        <Type element="h3" fontWeight="normal">
          {title}
        </Type>
        <DialogTitleActions onRequestClose={handleClose} />
      </DialogTitle>

      <Card
        borderTopColor="gray300"
        borderTopStyle="solid"
        borderTopWidth="1px"
      >
        <CardContent padding="md">
          <TabContext>
            <TabList>
              <DrugInteractionKeyTab label={definitions.title} fontSize="sm" />
              <DrugInteractionKeyTab
                label={documentationRatings.title}
                fontSize="sm"
              />
            </TabList>

            <Divider style={{ margin: "0 0 1.5rem" }} />

            <TabPanels>
              <TabPanel>
                {definitions.content.map((item) => {
                  return (
                    <Flex container key={item.title} marginBottom="md">
                      <DrugInteractionKeyIcon
                        icon={{
                          color: item.icon.color,
                          glyph: item.icon.glyph,
                          size: item.icon.size,
                        }}
                        background={{
                          color: item.icon.background,
                        }}
                      />
                      <DrugInteractionKeyItemTextContent column container>
                        <Type fontSize="sm" lineHeight="base">
                          {item.title}
                        </Type>
                        {item.description && (
                          <Type
                            element="p"
                            marginTop="xs"
                            fontSize="xs"
                            children={item.description}
                          />
                        )}
                      </DrugInteractionKeyItemTextContent>
                    </Flex>
                  );
                })}
              </TabPanel>
              <TabPanel>
                <List type="ul">
                  {documentationRatings.content.map((item) => {
                    return (
                      <DrugInteractionKeyTitleListItemWrapper
                        layout="flex"
                        key={item.title}
                      >
                        <DrugInteractionKeyTitleListItem>
                          <DrugInteractionKeyTitle fontSize="sm">
                            {item.title}
                          </DrugInteractionKeyTitle>
                          <Type
                            element="p"
                            marginTop="xs"
                            fontSize="xs"
                            children={item.description}
                          />
                        </DrugInteractionKeyTitleListItem>
                      </DrugInteractionKeyTitleListItemWrapper>
                    );
                  })}
                </List>
              </TabPanel>
            </TabPanels>
          </TabContext>
        </CardContent>
      </Card>
    </Dialog>
  );
};

SeverityInfoModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  title: PropTypes.string,
  definitions: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string,
        severityIndex: PropTypes.string,
        icon: PropTypes.shape({
          size: PropTypes.string.isRequired,
          glyph: PropTypes.string.isRequired,
          color: PropTypes.string,
          background: PropTypes.string,
        }),
      })
    ),
  }),
  documentationRatings: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string,
        documentationRating: PropTypes.string,
      })
    ),
  }),
};

export default SeverityInfoModal;
